import React from "react";
import { useObserver } from "mobx-react";
import { DnDLocalContainer } from "@containers/DnDContainer";
import { Paper, useTheme } from "@material-ui/core";
import { PrimaryButton } from "@components";
import locale from "@bonliva-crm/locale";
import { FileUpload, ArrowUp } from "mdi-material-ui";
import { makeStyles } from "@material-ui/styles";
import { ThemeType } from "@theme";
import { useConsultantEditorContext } from "../ConsultantEditorContext";
import { ConsultantEditorStore } from "../ConsultantEditorStore";
import { transparentize } from "polished";

export function ImportCVInfo() {
  const theme = useTheme();
  const store: ConsultantEditorStore = useConsultantEditorContext();
  const classes = useStyles({});
  return useObserver(() => {
    // if (store.isFileProcessing) {
    //   return <Spinner />;
    // }

    return (
      <DnDLocalContainer
        accept={store.importCvUploadConfig.acceptTypes}
        hideOverlay
        noClick
        onDrop={(files) => store.setFile(files[0])}
        render={({ isActive, isAccepted }) => {
          const activeText = isAccepted
            ? locale.dropFilesToUpload
            : locale.getFileUploadError(store.importCvUploadConfig.acceptString);
          const buttonText = isActive ? activeText : locale.SelectResume;

          const dragColor = transparentize(
            0.15,
            isAccepted ? theme.palette.secondary.main : theme.palette.error.main
          );

          return (
            <div className={classes.wrapper}>
              <Paper>
                <div className={classes.actions}>
                  {!store.file && (
                    <PrimaryButton
                      style={{
                        marginLeft: "auto",
                        backgroundColor: isActive ? dragColor : undefined
                      }}
                      leftIcon={<FileUpload fontSize="small" />}
                      onClick={store.selectFile}
                    >
                      {buttonText}
                    </PrimaryButton>
                  )}
                  {store.file && (
                    <PrimaryButton
                      onClick={store.processFile}
                      disabled={!store.isFileSelected}
                      loading={store.isFileProcessing}
                      rightIcon={store.file ? <ArrowUp fontSize="small" /> : null}
                    >
                      {locale.ImportFile(store.file ? store.file.name : "")}
                    </PrimaryButton>
                  )}
                </div>
              </Paper>
            </div>
          );
        }}
      />
    );
  });
}

const useStyles = makeStyles((theme: ThemeType) => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
  },

  root: {
    ...theme.mixins.childrenMarginBottom(16),
    align: "flex-start",
    marginBottom: "10%",
    padding: 16,
    textAlign: "center",
    width: "40rem"
  },

  actions: {
    ...theme.mixins.childrenMarginRight(8),
    display: "flex",
    alignItems: "flex-end"
  }
}));
